import { AdminBookingWebService } from '@linktivity/gds-neo';
import config from '../config';

const adminBookingApi = new AdminBookingWebService.BookingApi(config);

export default adminBookingApi;
